import { forwardRef, useCallback, useMemo, useState } from "react";
import { Virtuoso } from "react-virtuoso";

export const ListVirtualized = forwardRef(function ListVirtualized(
  { data, itemContent, reverse, infinite, components, ...props },
  ref
) {
  const readOnlyData = useMemo(() => {
    const readOnlyData = [...data];
    if (reverse) {
      readOnlyData.reverse();
    }
    return readOnlyData;
  }, [data, reverse]);

  const [infiniteLoading, setInfiniteLoading] = useState(false);
  const handleInfiniteGetter = useCallback(
    async (...args) => {
      if (!infiniteLoading && readOnlyData.length < infinite.total) {
        setInfiniteLoading(true);
        await infinite.getter(...args);
        setInfiniteLoading(false);
      }
    },
    [infiniteLoading, readOnlyData, infinite?.total, infinite?.getter]
  );

  const wrappedComponents = useMemo(() => {
    if (infinite) {
      return {
        [reverse ? "Header" : "Footer"]:
          infinite.skeleton && readOnlyData.length !== infinite.total ? infinite.skeleton : null,
        ...components,
      };
    } else {
      return { ...components };
    }
  }, [readOnlyData, components, reverse, infinite?.skeleton, infinite?.total]);

  return (
    <Virtuoso
      ref={ref}
      data={readOnlyData}
      itemContent={itemContent}
      firstItemIndex={infinite && reverse ? infinite.total - readOnlyData.length : 0}
      initialTopMostItemIndex={reverse ? readOnlyData.length - 1 : 0}
      startReached={infinite && reverse ? handleInfiniteGetter : undefined}
      endReached={infinite && !reverse ? handleInfiniteGetter : undefined}
      components={wrappedComponents}
      {...props}
    />
  );
});
